import {
  Box,
  Button,
  Checkbox,
  Step,
  StepButton,
  Stepper,
  TextareaAutosize,
  useMediaQuery,
  makeStyles,
  Typography,
  Paper,
  LinearProgress,
  Card,
  CardContent,
  IconButton,
  Grid,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../components";
import { useState, useEffect } from "react";
import { decrypt } from "../../utils/crypt";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import axios from "../../api";
import "../../App.css";
import { IoIosArrowBack, IoMdCheckmarkCircleOutline } from "react-icons/io";
import { motion, AnimatePresence } from "framer-motion";
import {
  MdOutlineSentimentVeryDissatisfied,
  MdOutlineSentimentDissatisfied,
  MdOutlineSentimentNeutral,
  MdOutlineSentimentSatisfied,
  MdOutlineSentimentVerySatisfied,
} from "react-icons/md";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(12),
  },
  container: {
    maxWidth: "800px",
    margin: "0 auto",
    padding: theme.spacing(2),
  },
  instructionCard: {
    borderRadius: "20px",
    // padding: theme.spacing(4),
    // boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
    backgroundColor: "transparent",
  },
  scaleCard: {
    padding: theme.spacing(3.5, 2),
    borderRadius: "28px",
    textAlign: "center",
    border: "2px solid",
    transition: "all 0.4s ease",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.05)",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 20px 30px -10px rgba(0, 0, 0, 0.1)",
    },
  },
  scaleNumber: {
    fontSize: "3.5rem",
    fontWeight: "800",
    lineHeight: 1,
    marginBottom: "4px",
  },
  scaleLabel: {
    fontSize: "10px",
    fontWeight: "800",
    textTransform: "uppercase",
    letterSpacing: "1px",
    marginTop: "8px",
  },
  questionCard: {
    // borderRadius: "20px",
    // padding: theme.spacing(3),
    border: "none",
    boxShadow: "none",
    backgroundColor: "transparent",
    minHeight: "300px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  chipContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "12px",
    marginTop: theme.spacing(4),
    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "repeat(5, 1fr)",
    },
  },
  previewCard: {
    borderRadius: "32px",
    padding: theme.spacing(4, 3),
    border: "2px dashed #9d2d3930",
    backgroundColor: "#f8fafc",
    marginTop: theme.spacing(3),
    position: "relative",
  },
  previewBadge: {
    position: "absolute",
    top: "-12px",
    right: "24px",
    backgroundColor: "#9d2d39",
    color: "white",
    padding: "4px 16px",
    borderRadius: "10px",
    fontSize: "12px",
    fontWeight: "800",
    boxShadow: "0 4px 10px rgba(157, 45, 57, 0.2)",
  },
  responseChip: {
    padding: "22px 10px",
    borderRadius: "32px",
    border: "2px solid #f1f5f9",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
    backgroundColor: "white",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)",
    gap: "8px",
    "&:hover": {
      borderColor: "#e2e8f0",
      transform: "translateY(-8px)",
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.05)",
    },
  },
  sentimentIcon: {
    fontSize: "44px",
    color: "#94a3b8",
    transition: "all 0.4s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  chipNumberText: {
    fontSize: "12px",
    fontWeight: "600",
    color: "#64748b",
    lineHeight: 1,
    marginTop: "4px",
  },
  chipLabel: {
    fontSize: "10px",
    fontWeight: "800",
    color: "#94a3b8",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    textAlign: "center",
    lineHeight: 1.2,
  },
  activeChip: {
    backgroundColor: "#9d2d39",
    borderColor: "#9d2d39",
    transform: "scale(1.05) translateY(-8px)",
    boxShadow: "0 20px 25px -5px rgba(157, 45, 57, 0.3)",
    "& $sentimentIcon": {
      color: "white",
      transform: "scale(1.1)",
    },
    "& $chipNumberText": {
      color: "white",
    },
    "& $chipLabel": {
      color: "rgba(255, 255, 255, 0.9)",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(3),
    // backgroundColor: "white",
    // padding: "15px 20px",
    // borderRadius: "20px",
    // boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)",
  },
  backBtn: {
    backgroundColor: "#f1f5f9",
    borderRadius: "14px",
    marginRight: theme.spacing(2),
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#e2e8f0",
      transform: "translateX(-3px)",
    },
  },
  titleHeader: {
    fontWeight: "700",
    color: "#0f172a",
    fontSize: "1.2rem",
    letterSpacing: "-0.01em",
  },
  stepper: {
    backgroundColor: "transparent",
    padding: theme.spacing(2, 0),
    "& .MuiStepConnector-line": {
      borderColor: "#e2e8f0",
      borderTopWidth: "3px",
      borderRadius: "10px",
    },
    "& .MuiStepConnector-active .MuiStepConnector-line": {
      borderColor: "#9d2d39",
    },
    "& .MuiStepConnector-completed .MuiStepConnector-line": {
      borderColor: "#10b981",
    },
  },
  stepLabel: {
    "& .MuiStepLabel-label": {
      fontSize: "12px",
      fontWeight: "600",
      color: "#94a3b8",
      marginTop: "8px",
      "&.MuiStepLabel-active": { color: "#0f172a" },
      "&.MuiStepLabel-completed": { color: "#10b981" },
    },
  },
  customStepIcon: {
    width: "32px",
    height: "32px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "800",
    fontSize: "14px",
    transition: "all 0.3s ease",
  },
  // questionCard: {
  //   // borderRadius: "32px",
  //   // padding: theme.spacing(4, 3.5),
  //   // boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.05)",
  //   backgroundColor: "transparent",
  //   minHeight: "360px",
  //   display: "flex",
  //   flexDirection: "column",
  //   justifyContent: "flex-start",
  //   border: "1px solid #f1f5f9",
  // },
  questionText: {
    fontWeight: "500",
    letterSpacing: "-1px",
    lineHeight: 1.4,
    color: "#1e293b",
    // marginBottom: theme.spacing(5),
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.4rem",
    },
  },
  progressBar: {
    height: "10px",
    borderRadius: "10px",
    backgroundColor: "#f1f5f9",
    "& .MuiLinearProgress-bar": {
      backgroundColor: "#9d2d39",
      borderRadius: "10px",
    },
  },
  responseChip: {
    padding: "20px",
    borderRadius: "22px",
    border: "2px solid #f1f5f9",
    textAlign: "center",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
    backgroundColor: "white",
    "&:hover": {
      borderColor: "#9d2d3990",
      transform: "translateY(-4px)",
      boxShadow: "0 12px 20px -5px rgba(0, 0, 0, 0.1)",
    },
  },
  activeChip: {
    backgroundColor: "#9d2d39",
    borderColor: "#9d2d39",
    color: "white",
    transform: "scale(1.02)",
    boxShadow: "0 12px 20px -5px rgba(157, 45, 57, 0.35)",
    "& .MuiTypography-root": { color: "white" },
    "& p": { color: "white" },
    "& span": { color: "rgba(255,255,255,0.7)" },
  },
  navButtons: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "rgba(255,255,255,0.9)",
    backdropFilter: "blur(16px)",
    padding: theme.spacing(2.5, 4),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: 1000,
    borderTop: "1px solid #f1f5f9",
  },
  footerBtn: {
    borderRadius: "16px",
    padding: "14px 32px",
    fontWeight: "700",
    textTransform: "none",
    transition: "all 0.3s ease",
  },
  finishedContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: theme.spacing(8, 4),
    backgroundColor: "transparent",
    borderRadius: "48px",
    // boxShadow: "0 40px 80px -20px rgba(0, 0, 0, 0.12)",
    marginTop: "10vh",
    width: "100%",
    maxWidth: "600px",
    margin: "0 auto",
  },
  checkIcon: {
    fontSize: "120px",
    color: "#10b981",
    marginBottom: theme.spacing(4),
    // filter: "drop-shadow(0 15px 30px rgba(16, 185, 129, 0.3))",
  },
  celebrationTitle: {
    fontWeight: "800",
    color: "#0f172a",
    fontSize: "2.2rem",
    marginBottom: theme.spacing(2),
    letterSpacing: "-0.02em",
  },
  successSubtext: {
    color: "#64748b",
    fontSize: "1.1rem",
    maxWidth: "400px",
    margin: "0 auto",
    lineHeight: 1.6,
  },
  actionBtn: {
    borderRadius: "20px",
    padding: "18px 48px",
    fontWeight: "800",
    textTransform: "none",
    fontSize: "1rem",
    // boxShadow: "0 10px 20px -5px rgba(157, 45, 57, 0.3)",
    transition: "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
    "&:hover": {
      transform: "translateY(-4px) scale(1.02)",
      boxShadow: "0 20px 30px -10px rgba(157, 45, 57, 0.4)",
    },
  },
}));

const PollTeacher = (props) => {
  const classes = useStyles();
  const params = useParams();
  const history = useNavigate();
  const isMobile = useMediaQuery("(max-width: 700px)");

  const [competencias, setCompetencias] = useState([]);
  const [showInstructions, setShowInstructions] = useState(true);
  const [activeStep, setActiveStep] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [comments, setComments] = useState("");
  const [orden, setOrden] = useState(0);
  const [blockButton, setBlockButton] = useState(false);
  const [vp_tipo_encuesta, setVp_tipo_encuesta] = useState(0);
  const [finished, setFinished] = useState(false);
  const [loading, setLoading] = useState(true);

  const { token } = props;
  const dataId = decrypt(params.id);

  const getQuestions = async () => {
    try {
      const { data } = await axios.post(
        "/evaluations/getQuestions",
        {
          data: { id: dataId },
        },
        {
          headers: { "access-token": token },
        },
      );

      const { dataResult, response } = data.respuesta;
      setVp_tipo_encuesta(dataResult[0].vp_tipo_encuesta);

      if (dataResult.length > 0) {
        const questionsList = dataResult[0]?.detalleEncuestas.map(
          (item) => item.preguntas,
        );
        let competitionListTemp = [];
        const list = questionsList.map((item) => {
          const calificacion = response.find(
            (item2) => item2.id_preguntas === item.id,
          );
          const value = item?.escalaMedicion?.detalleEscalaMedicion.map(
            (item3) => ({
              rotulo: item3.rotulo,
              value: item3.valor,
              status: calificacion
                ? item3.valor === calificacion.calificacion
                : false,
            }),
          );
          competitionListTemp.push(item.competencia);
          return { ...item, value };
        });

        let hash = {};
        let competitionList = competitionListTemp
          .filter((current) => {
            var exists = !hash[current.id];
            hash[current.id] = true;
            return exists;
          })
          .sort((p1, p2) => p1.orden - p2.orden);

        competitionList.push({
          id: 32,
          nombre: "Comentarios",
          orden: 99,
          estado: 1,
        });

        setOrden(response[0]?.orden || 0);
        setCompetencias(competitionList);
        setQuestions(list);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getQuestions();
  }, []);

  const activeCheck = (id, ratingValue) => {
    const newList = questions.map((item) => {
      if (item.id === id) {
        item.value = item.value.map((v) => ({
          ...v,
          status: v.value === ratingValue,
        }));
      }
      return item;
    });
    setQuestions(newList);
  };

  const handleNextQuestion = async () => {
    const currentComp = competencias[activeStep];
    const compQuestions = questions.filter(
      (q) => q.id_competencias === currentComp.id,
    );

    if (currentComp.id === 32) {
      if (comments.trim().length < 4) {
        Swal.fire({
          icon: "warning",
          text: "Escribe un comentario un poco más largo.",
        });
        return;
      }
      await salveEvaluation();
      return;
    }

    const currentQ = compQuestions[currentQuestionIndex];
    const hasAnswer = currentQ.value.some((v) => v.status);

    if (!hasAnswer) {
      Swal.fire({
        icon: "warning",
        text: "Por favor selecciona una calificación.",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    if (currentQuestionIndex < compQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      // End of competency section
      await salveSection();
    }
  };

  const handleBackQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    } else if (activeStep > 0) {
      const prevComp = competencias[activeStep - 1];
      const prevCompQuestions = questions.filter(
        (q) => q.id_competencias === prevComp.id,
      );
      setActiveStep(activeStep - 1);
      setCurrentQuestionIndex(prevCompQuestions.length - 1);
    }
  };

  const salveSection = async () => {
    setBlockButton(true);
    const currentComp = competencias[activeStep];
    const compQuestions = questions.filter(
      (q) => q.id_competencias === currentComp.id,
    );

    const answers = compQuestions.map((q) => ({
      id: q.id,
      calificacion: q.value.find((v) => v.status).value,
    }));

    try {
      await axios.post(
        "/evaluations/salveEvaluationDetail",
        {
          data: {
            orden,
            id_evaluacion: dataId,
            preguntas: answers,
          },
        },
        {
          headers: { "access-token": token },
        },
      );

      setOrden((prev) => prev + answers.length);
      setActiveStep(activeStep + 1);
      setCurrentQuestionIndex(0);
    } catch (e) {
      console.error(e);
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: "Hubo un problema al guardar esta sección. Por favor intenta de nuevo.",
      });
    }
    setBlockButton(false);
  };

  const salveEvaluation = async () => {
    const data = {
      id_evaluacion: dataId,
      fecha_final: new Date(),
      juicio_evaluativo: comments.trim(),
      vp_tipo_encuesta,
    };

    try {
      const { data: res } = await axios.post(
        "evaluations/endEvaluation",
        { data },
        {
          headers: { "access-token": token },
        },
      );
      if (res.respuesta) {
        setFinished(true);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error al finalizar",
          text:
            res.message || "No se pudo marcar la evaluación como terminada.",
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        text: "Error de conexión al finalizar la encuesta.",
      });
    }
  };

  const currentComp = competencias[activeStep];
  const compQuestions = questions.filter(
    (q) => q.id_competencias === currentComp?.id,
  );
  const displayQuestion = compQuestions[currentQuestionIndex];

  if (finished) {
    return (
      <div
        className={classes.root}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className={classes.container}>
          <motion.div
            initial={{ opacity: 0, y: 40, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            className={classes.finishedContainer}
          >
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
            >
              <IoMdCheckmarkCircleOutline className={classes.checkIcon} />
            </motion.div>

            <Typography variant="h4" className={classes.celebrationTitle}>
              ¡Evaluación Completada!
            </Typography>

            <Typography className={classes.successSubtext}>
              Muchas gracias por tu tiempo. Tu opinión es el motor principal
              para elevar nuestra excelencia académica.
            </Typography>

            <Box mt={6} width="100%" display="flex" justifyContent="center">
              <Button
                variant="contained"
                className={classes.actionBtn}
                style={{
                  backgroundColor: "#9d2d39",
                  color: "white",
                }}
                onClick={() => history("/evaluation")}
              >
                Volver al Menú Principal
              </Button>
            </Box>
          </motion.div>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <AnimatePresence mode="wait">
          {showInstructions ? (
            <motion.div
              key="instructions"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
            >
              <Paper className={classes.instructionCard} elevation={0}>
                <Box textAlign="center" mb={4}>
                  <Typography
                    variant="h4"
                    style={{
                      fontWeight: "800",
                      color: "#0f172a",
                      marginBottom: "12px",
                    }}
                  >
                    Bienvenido, Estudiante
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{
                      color: "#64748b",
                      maxWidth: "600px",
                      margin: "0 auto",
                    }}
                  >
                    Tu opinión es fundamental para mejorar nuestra calidad
                    académica. A continuación, verás un ejemplo de cómo
                    calificar a tus docentes.
                  </Typography>
                </Box>

                <div className={classes.previewCard}>
                  <div className={classes.previewBadge}>VISTA PREVIA</div>
                  <Typography
                    variant="h5"
                    className={classes.questionText}
                    style={{ fontSize: "1.3rem", marginBottom: "2rem" }}
                  >
                    ¿Cómo califica el desempeño general del docente en esta
                    asignatura?
                  </Typography>

                  <div className={classes.chipContainer}>
                    {[
                      {
                        n: 1,
                        t: "Muy Deficiente",
                        icon: <MdOutlineSentimentVeryDissatisfied />,
                      },
                      {
                        n: 2,
                        t: "Deficiente",
                        icon: <MdOutlineSentimentDissatisfied />,
                      },
                      {
                        n: 3,
                        t: "Regular",
                        icon: <MdOutlineSentimentNeutral />,
                      },
                      {
                        n: 4,
                        t: "Bueno",
                        icon: <MdOutlineSentimentSatisfied />,
                      },
                      {
                        n: 5,
                        t: "Excelente",
                        icon: <MdOutlineSentimentVerySatisfied />,
                      },
                    ].map((item) => (
                      <div
                        key={item.n}
                        className={classes.responseChip}
                        style={{ pointerEvents: "none" }}
                      >
                        <div
                          className={classes.sentimentIcon}
                          style={{ fontSize: "36px", color: "#9d2d39" }}
                        >
                          {item.icon}
                        </div>
                        <Typography className={classes.chipNumberText}>
                          {item.n}
                        </Typography>
                        <Typography className={classes.chipLabel}>
                          {item.t}
                        </Typography>
                      </div>
                    ))}
                  </div>
                </div>

                <Box mt={6} textAlign="center">
                  <Typography
                    variant="body2"
                    style={{
                      color: "#94a3b8",
                      marginBottom: "2rem",
                      fontStyle: "italic",
                    }}
                  >
                    * Selecciona la opción que mejor describa cada situación.
                    ¡Es muy sencillo!
                  </Typography>
                  <Button
                    variant="contained"
                    size="large"
                    style={{
                      backgroundColor: "#9d2d39",
                      color: "white",
                      borderRadius: "18px",
                      // padding: "16px 80px",
                      fontWeight: "900",
                      fontSize: "18px",
                      boxShadow: "none",
                      textTransform: "none",
                      transition: "all 0.3s ease",
                    }}
                    onClick={() => setShowInstructions(false)}
                  >
                    Comenzar Evaluación
                  </Button>
                </Box>
              </Paper>
            </motion.div>
          ) : (
            <motion.div
              key="poll"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
            >
              <div className={classes.header}>
                <IconButton
                  onClick={() => history("/evaluation")}
                  className={classes.backBtn}
                  size="small"
                >
                  <IoIosArrowBack size={24} />
                </IconButton>
                <Typography variant="h6" className={classes.titleHeader}>
                  Evaluación del Docente
                </Typography>
              </div>

              <Stepper
                activeStep={activeStep}
                alternativeLabel
                className={classes.stepper}
              >
                {competencias.map((item, idx) => (
                  <Step key={item.id}>
                    <StepButton
                      disabled
                      className={classes.stepLabel}
                      icon={
                        <div
                          className={classes.customStepIcon}
                          style={{
                            backgroundColor:
                              idx === activeStep
                                ? "#9d2d39"
                                : idx < activeStep
                                  ? "#10b981"
                                  : "#e2e8f0",
                            color: idx <= activeStep ? "white" : "#94a3b8",
                            // boxShadow:
                            //   idx === activeStep
                            //     ? "0 4px 10px rgba(157, 45, 57, 0.3)"
                            //     : "none",
                          }}
                        >
                          {idx + 1}
                        </div>
                      }
                    >
                      {/* {!isMobile || idx === activeStep ? item.nombre : ""} */}
                    </StepButton>
                  </Step>
                ))}
              </Stepper>

              <Box mb={2}>
                <LinearProgress
                  variant="determinate"
                  className={classes.progressBar}
                  value={
                    ((currentQuestionIndex + 1) / compQuestions.length) * 100
                  }
                />
                <Box display="flex" justifyContent="space-between" mt={1}>
                  <Typography variant="caption" color="textSecondary">
                    Pregunta {currentQuestionIndex + 1} de{" "}
                    {compQuestions.length}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    style={{ fontWeight: "bold" }}
                  >
                    {currentComp?.nombre}
                  </Typography>
                </Box>
              </Box>

              <AnimatePresence mode="wait">
                <motion.div
                  key={`${activeStep}-${currentQuestionIndex}`}
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -20 }}
                  transition={{ duration: 0.2 }}
                >
                  {loading ? (
                    <Box mt={2}>
                      <Skeleton
                        variant="rect"
                        width="80%"
                        height={40}
                        style={{ borderRadius: "15px", marginBottom: "3rem" }}
                      />
                      <div className={classes.chipContainer}>
                        {[1, 2, 3, 4, 5].map((i) => (
                          <Skeleton
                            key={i}
                            variant="rect"
                            width="100%"
                            height={150}
                            style={{ borderRadius: "32px" }}
                            animation="pulse"
                          />
                        ))}
                      </div>
                    </Box>
                  ) : currentComp?.id === 32 ? (
                    <Card className={classes.questionCard} elevation={0}>
                      <Typography
                        variant="h6"
                        gutterBottom
                        style={{ fontWeight: "bold" }}
                      >
                        Comentarios Adicionales
                      </Typography>
                      <TextareaAutosize
                        minRows={5}
                        placeholder="Comparte tu opinión sobre el docente..."
                        style={{
                          width: "100%",
                          padding: "15px",
                          borderRadius: "12px",
                          border: "1px solid #ddd",
                          fontSize: "1rem",
                          outline: "none",
                        }}
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                      />
                    </Card>
                  ) : (
                    displayQuestion && (
                      <Card className={classes.questionCard} elevation={0}>
                        <Typography
                          variant="h4"
                          className={classes.questionText}
                        >
                          {displayQuestion.pregunta}
                        </Typography>

                        <div className={classes.chipContainer}>
                          {displayQuestion.value.map((rating) => {
                            const icons = {
                              1: (
                                <MdOutlineSentimentVeryDissatisfied
                                  color={rating.status ? "#FFF" : "#9d2d39"}
                                  size={90}
                                />
                              ),
                              2: (
                                <MdOutlineSentimentDissatisfied
                                  color={rating.status ? "#FFF" : "#9d2d39"}
                                  size={90}
                                />
                              ),
                              3: (
                                <MdOutlineSentimentNeutral
                                  color={rating.status ? "#FFF" : "#9d2d39"}
                                  size={90}
                                />
                              ),
                              4: (
                                <MdOutlineSentimentSatisfied
                                  color={rating.status ? "#FFF" : "#9d2d39"}
                                  size={90}
                                />
                              ),
                              5: (
                                <MdOutlineSentimentVerySatisfied
                                  color={rating.status ? "#FFF" : "#9d2d39"}
                                  size={90}
                                />
                              ),
                            };
                            return (
                              <div
                                key={rating.value}
                                className={`${classes.responseChip} ${rating.status ? classes.activeChip : ""}`}
                                onClick={() =>
                                  activeCheck(displayQuestion.id, rating.value)
                                }
                              >
                                <div className={classes.sentimentIcon}>
                                  {icons[rating.value]}
                                </div>
                                <Typography className={classes.chipNumberText}>
                                  {rating.value}
                                </Typography>
                                <Typography className={classes.chipLabel}>
                                  {rating.rotulo}
                                </Typography>
                              </div>
                            );
                          })}
                        </div>
                      </Card>
                    )
                  )}
                </motion.div>
              </AnimatePresence>

              <div className={classes.navButtons}>
                <Button
                  onClick={handleBackQuestion}
                  disabled={activeStep === 0 && currentQuestionIndex === 0}
                  className={classes.footerBtn}
                  startIcon={<IoIosArrowBack />}
                  style={{
                    color:
                      activeStep === 0 && currentQuestionIndex === 0
                        ? "#cbd5e1"
                        : "#64748b",
                  }}
                >
                  Anterior
                </Button>
                <Button
                  variant="contained"
                  className={classes.footerBtn}
                  style={{
                    backgroundColor: "#9d2d39",
                    color: "white",
                    boxShadow: "none",
                  }}
                  onClick={handleNextQuestion}
                  disabled={blockButton}
                >
                  {activeStep === competencias.length - 1
                    ? "Finalizar Proyecto"
                    : "Siguiente"}
                </Button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.token,
});

export default connect(mapStateToProps)(PollTeacher);